// Map for bus company options
export const BusCompanyMap: Record<string, string> = {
  Dr_Richard: 'Dr. Richard',
  Panorama_Reisen: 'Panorama Reisen',
  Airportlink: 'Airportlink',
  Zwoelfer_Reisen: 'Zwölfer Reisen',
  Sonstige: 'Sonstige',
};

// Map for standard vehicle types
export const VehicleTypeMap: Record<string, string> = {
  Taxi: 'Taxi',
  Minivan: 'Minivan',
  '20': '20',
  '30': '30',
  '38': '38',
  '50': '50',
  '60': '60',
};

// Map for tour options
export const TourMapLEGACY: Record<string, string> = {
  Citytour: 'Citytour',
  Schoenbrunn: 'Schönbrunn',
  Citytour_Schoenbrunn: 'Citytour & Schönbrunn',
  Citytour_KHM: 'Citytour & KHM',
  Naschmarkt: 'Naschmarkt',
  Konzerthaus_Cafe: 'Konzerthaus & Café',
  Kapuzinergruft_Nat_Bibliothek: 'Kapuzinergruft & Nat.Bibliothek',
  Fiaker: 'Fiaker',
  Konzert_Eschenbach: 'Konzert Eschenbach',
  Konzert_Stadtpalais_Liechtenstein: 'Konzert Stadtpalais Liechtenstein',
  Konzert_Sonstige: 'Konzert Sonstige',
  Shuttle: 'Shuttle',
  Citytour_Weihnachtsmarkt: 'Citytour & Weihnachtsmarkt',
  Hofburg: 'Hofburg',
  Airport_Transfer: 'Airport Transfer',
  Stift_Melk: 'Stift Melk',
  Duernstein: 'Dürnstein',
  Artstetten: 'Artstetten',
  Linz: 'Linz',
  Bike_Tour: 'Bike Tour',
  Sonstige: 'Sonstige',
};

export const JettyMap: Record<string, string> = {
  Linz: 'Linz',
  Melk: 'Melk',
  Duernstein: 'Dürnstein',
  Handelskai1: 'Handelskai 1',

  Handelskai2: 'Handelskai 2',

  Handelskai3: 'Handelskai 3',

  Handelskai4: 'Handelskai 4',

  Handelskai5: 'Handelskai 5',

  Handelskai6: 'Handelskai 6',

  Handelskai7: 'Handelskai 7',

  Handelskai8: 'Handelskai 8',

  Handelskai9: 'Handelskai 9',

  Handelskai10: 'Handelskai 10',

  Handelskai11: 'Handelskai 11',

  Handelskai12: 'Handelskai 12',
  Nussdorf: 'Nussdorf',
  Bratislava: 'Bratislava',
  Prag: 'Prag',
  Passau: 'Passau',
  Budapest: 'Budapest',
  Grein: 'Grein',
  Hainburg: 'Hainburg',
  Ybbs: 'Ybbs',
  Krems: 'Krems',
  Vukovar: 'Vukovar',
  Mohacs: 'Mohács',
  Samorin: 'Šamorín',
  Freudenau: 'Freudenau',
  Engelhartszell: 'Engelhartszell',
  Tulln: 'Tulln',
  Graz: 'Graz',
  Innsbruck: 'Innsbruck',
  Salzburg: 'Salzburg',
};

export const StornoMap: Record<string, string> = {
  Hochwasser: 'Hochwasser',
  Guide_Storniert: 'Guide Storniert',
  TourentauschGuide: 'Tourentausch mit anderem Guide',
  TourentauschSchiff: 'Tausch mit anderem Schiff',
  WenigAnmeldungen: 'Zu wenig Anmeldungen',
  other: 'Sonstiges',
};

export const colorMap: Record<string, string> = {
  Avalon: '#F8CAAD', // peach
  APT: '#FFFF99', // pale yellow
  DESTIN: '#ADFFD6', // mint
  Lüftner: '#E6ADFF', // lavender
  'Kalos Golf': '#FFE0AD', // light apricot
  CROISIEurope: '#C0E6F5', // pale cyan
  'Blue Danube Tours': '#ADCBFF', // pastel periwinkle
  'CITS Congress-Incentive-Travel-Service GmbH': '#FFADDC', // soft pink
  Travelmarvel: '#FFD966', // light orange
};
